import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName, rawValueToEnum } from '../utils';

/** 面積単位 */
enum AreaUnit {
  squareMeter = '10',
  tsubo = '11',
  hectare = '12',
}

const nameConfig = {
  squareMeter: new Map([
    [Locale.ja, '平米'],
    [Locale.en, 'Square Meter'],
  ]),
  tsubo: new Map([
    [Locale.ja, '坪'],
    [Locale.en, 'Tsubo'],
  ]),
  hectare: new Map([
    [Locale.ja, 'ヘクタール'],
    [Locale.en, 'Hectare'],
  ]),
};

const toEnum = rawValueToEnum(AreaUnit, '');
const toDisplay = enumToName(AreaUnit, nameConfig);
const toDisplayWithPrefix = enumToName(AreaUnit, nameConfig, { prefix: true });

export const areaUnit = {
  enum: AreaUnit,
  nameConfig,
  toEnum,
  toDisplay,
  toDisplayWithPrefix,
};
export type { AreaUnit };
